<template>
  <div class="tour-card">
    <!-- image and flag -->
    <nuxt-link :to="'/' + data.citySlug + '/' + data.slug + '/'" class="image-link" @click.native="productClick">
      <div class="thumbnail">
        <img :data-src="getImageSrc(data.image)" :data-srcset="getImageSrcSet(data.image)" class="lazyload tour-image" />
        <div v-if="data.flag && !showPromoTag" class="flag" :class="{ private: data.flag === 'Private Tour', unavailable: data.flag === 'Currently Unavailable', 'newly': data.flag === 'Newly Launched' }">{{ data.flag }}</div>
        <div v-if="showPromoTag" class="promo-tag" :style="getPromoStyle">{{ getPromoLabel() }}</div>
      </div>
    </nuxt-link>
    <!-- tour title, review and description -->
    <div class="detail-wrapper">
      <div>
        <nuxt-link :to="'/' + data.citySlug + '/' + data.slug + '/'" @click.native="productClick">
          <h3 class="red" v-html="formatedName"></h3>
        </nuxt-link>
        <ReviewLine class="desktop-review review-line"
          :show-hours="false"
          :show-capacity="false"
          :review="{stars: rate, reviewNumber: count}"
        />
      </div>
      <div class="tour-description">
        <div class="card-text">{{ data.listingText }}</div>
      </div>
    </div>
    <!-- price and view tour button -->
    <div class="button-price card-content">
      <div v-if="!data.unavailabile" class="card-price flex">
        <span class="price-prefix">from</span>

        <div class="price-container-wrapper" v-if="getPrice(data) !== '$0' && getDiscountPrice(data) === '$0'">
          <span class="dollar-prefix" v-if="getPrefixSymbol()">
            {{ getPrefixSymbol() }}
          </span>
          <span>{{ getPrice(data) }}</span>
        </div>

        <div class="price-container-wrapper" v-if="getPrice(data) !== '$0' && getDiscountPrice(data) !== '$0'">
          <span class="dollar-prefix discounted-dollar-prefix" v-if="getPrefixSymbol()">
            {{ getPrefixSymbol() }}
          </span>
          <div class="price-container">
            <span class="strikethrough">{{ getPrice(data) }}</span>
            <span class="discounted-price">{{ getDiscountPrice(data) }}</span>
          </div>
        </div>
      </div>
      <nuxt-link :to="'/' + data.citySlug + '/' + data.slug  + '/'" @click.native="productClick" style="margin-left: auto;">
        <div class="book-tour-anchor btn-anim">VIEW TOUR</div>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import saleInfo from '~/static/json/promo.json'

// import RatingReview from '@/components/utils/RatingReview'
import ReviewLine from '~/components/utils/ReviewLine'
import LazyBackground from '@/components/utils/LazyBackground'

import promoMixin from  '~/mixins/promoMixin.js'
import CurrencyMixin from '@/mixins/CurrencyMixin'
import imageOptimo from '~/mixins/imageOptimoMixin.js'

export default {
  name: 'TourCard',
  mixins: [CurrencyMixin, promoMixin,imageOptimo],
  components: {
    // RatingReview,
    ReviewLine,
    LazyBackground
  },
  created () {
    this.strikePromoBolean = this.checkForPromo(saleInfo.events, this.data.event_id)
  },
  data: () => {
    return {
      strikePromoBolean: false,
      saleInfo: saleInfo
    }
  },
  computed: {
    ...mapGetters([
      'screenWidth'
    ]),
    // remove unicode trademark
    formatedName () {
      return this.data.name.replace(/&trade;/i, `<span class='sup'>TM</span>`)
    },
    rate () {
      return this.data.reviewStatus.feedbackAverage
    },
    count () {
      return this.data.reviewStatus.feedbackCount
    },
    showPromoTag () {
      if (this.data?.promo?.show && !this.data.unavailable && this.data?.promo?.promoLocation?.includes('Tour Listing Card')) {
        return true
      } else {
        return false
      }
    },
    getPromoStyle () {
      if (this.showPromoTag && this.data.promo.promoTag) {
        return `
          background-color: ${this.data.promo.promoTag.bgColor};
          color: ${this.data.promo.promoTag.textColor};
        `
      } else {
        return ''
      }
    },
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    position: {
      type: Number,
      required: true
    },
    list: {
      type: String,
      required: true
    }
  },
  methods: {
    getImageSrc(imgUrl) {
      return this.getContentfulImgURL({ url: imgUrl });
    },
    getImageSrcSet(imgUrl) {
      return this.getImageSrcSetURL({ url: imgUrl, scale: 4 });
    },
    productClick () {
      window.dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
          'click': {
            'actionField': {'list': this.list},
            'products': [{
              'name': this.data.titleShort,
              'id': this.data.bookingTypeId,
              'price': this.getAnchorPriceNum(this.data),
              'category': this.data.citySlug.replace('-tours', '').charAt(0).toUpperCase() + this.data.citySlug.replace('-tours', '').slice(1),
              'position': this.position
            }]
          }
        }
      })
    },
    getPromoLabel () {
      if (this.showPromoTag) {
        return this.data.promo?.promoTag?.salesText
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$padding: 30px;
.card-price.flex {
  display: flex;
  align-items: center;
}
.price-container-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}
.price-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}
.discounted-price {
  color: #a08f56;
}
.strikethrough {
  text-decoration: line-through;
  font-size: 30px;
  line-height: 30px;
}
.price-prefix{
  font-family: Vollkorn;
  color:$woi-red-main;
  margin-right: 5px;
  @extend %title-1-bold;
}
.dollar-prefix {
  font-size: 26px;
}
// .discounted-dollar-prefix {
//   font-size: 14px;
// }

.tour-card {
  display: flex;
  border-bottom: 1px solid $woi-grey-light;
  &:last-child {
    border-bottom: none;
  }
  padding-bottom: $padding;
  &:not(:first-child) {
    padding-top: $padding;
  }
  .detail-wrapper {
    flex: 1;
  }
  > * {
    &:not(:first-child) {
      border-left: $padding solid transparent;
    }
  }
    .strike-through {
      font-family: "Vollkorn";
      color: $woi-red-main;
      float: left;
      margin: auto 0;
      font-weight: 600;
      text-decoration: line-through;
    }
    .thumbnail {
      position: relative;
      overflow: hidden;
      width: $tour-pic-height;
      height: $tour-pic-height;
      .tour-image {
        width: 100%;
        height: $tour-pic-height;
        align-self: flex-start;
        object-fit: cover;
        transition: transform 940ms $cb-switch;
        &:hover {
          transform: scale(1.07) rotate(-.33deg);
        }
      }
      .flag {
        position: absolute;
        bottom: 0;
        height: $flag-height;
        background-color: $golden-starlight;
        color: $white;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        font-family: $font-sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;

        &.private {
          background-color: $blueberry-light;
        }

        &.unavailable {
          background-color: $grey-3;
        }

        &.newly {
          background-color: $light-brown;
        }
      }
    }
    h3.red {
      text-transform: none!important;
      @include woi-header-5;
      color: $woi-red-main;
      &:hover {
          text-decoration: underline;
      }
    }
    .tour-description {
      margin-top: 12px;
      .card-text {
        @include paragraph-1;
        font-family: $font-sans-serif;
        line-height: 22px;
        color: $blackberry;
      }
    }

    .mobile-review {
    }
    .button-price {
      margin-top: auto;
      margin-bottom: auto;
      flex: 0 0 150px;
      .card-price.flex {
        @extend %header-3;
      }
    }
    .rate {
      width: 150px;
      height: 50px;
    }
  }

@include max-width($tablet-portrait){
  .tour-card {
    display: grid;
    border-bottom: 1px solid #dfdfdf;;
    grid-template-columns: $tour-pic-height 30px auto;
    > * {
      &:not(:first-child) {
        border-left: none;
      }
    }
    .thumbnail .flag {
      height: $mobile-flag-height;
      font-size: 13px;
      line-height: 16px;
    }
    .image-link {
      grid-column: 1 / 2;
      grid-row: 1 / 2;
    }
    .detail-wrapper {
      grid-column: 3 / 4;
      grid-row: 1 / 2;
    }
    .mobile-review {
      margin-top: 12px;
      grid-column: 1 / 4;
      grid-row: 2 / 3;
    }
    .button-price {
      grid-column: 1 / 4;
      grid-row: 3 / 4;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 8px;
      .card-price.flex {
        @include woi-header-4;
        margin: 0;
      }
    }
    .dollar-prefix {
      margin-right: -4px;
    }
  }
}

@include max-width($mobile){
  .strikethrough {
    text-decoration: line-through;
    font-size: 20px;
    line-height: 20px;
  }
  .tour-card {
    grid-template-columns: 153px 30px auto;
    .button-price {
      .card-price.flex {
        @include header-5 ;
        font-weight: 600 !important;
        margin: 0;
        .price-prefix {
          font-size: 22px;
        }
      }
    }
    .thumbnail {
      width: $mobile-tour-pic;
      height: $mobile-tour-pic;
      .tour-image {
        width: 100%;
        height: 100%;
      }
      .flag {
        height: $mobile-flag-height - 4px;
        // @include subtitle-2;
        // font-size: 18px;
        // line-height: 26px;
        text-transform: none;
      }
    }
    h3.red {
      font-size: 18px !important;
      line-height: 26px;
    }
    .tour-description {
      margin-top: 0;
      .card-text {
        @include paragraph-1;
      }
    }
    .dollar-prefix {
      margin-right: -4px;
    }
  }
}
@include max-width(490px){
  .tour-card .tour-description {
    display: none;
  }
}
@include max-width($mobile-l){
  .tour-card {
    .dollar-prefix {
      margin-right: -4px;
    }
  }
}

.promo-tag {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 12px 8px;
  font-weight: 900;
  font-size: 18px;
  color: #F7F7F7;
  background-color: #1BB2EB;
}
</style>
